import React from 'react'
import { useGoogleAccountStore } from '../../stores/GoogleAccount'
import { useIntl } from 'react-intl'
interface BtnGoogleLoginProps {
    login: () => void
}

const BtnGoogleLogin: React.FC<BtnGoogleLoginProps> = ({ login }) => {
    const { isLoadingGoogleAccount } = useGoogleAccountStore()
    const intl = useIntl()

    return (
        <button className='btn d-flex align-items-center gap-2 p-2'
            disabled={isLoadingGoogleAccount}
            style={
                {
                    border: '0.7px solid #adadad',
                    borderRadius: '7px',
                }}
            onClick={() => login()}>
            <img src={'/media/assets/google.png'} alt='google' style={{
                width: '25px',
                height: '25px',
            }} />
            {intl.formatMessage({ id: 'FORM.ACTION.SIGN_IN_WITH_GOOGLE' })}
        </button>
    )
}

export default BtnGoogleLogin